<template>
  <div class="page">
    <div class="container">
      <div class="page__row">
        <div class="page__inner">
          <h1 class="title title_red page__title">Отношение</h1>
          <p class="lead page__lead" style="margin-bottom: auto">Мы ценим открытые отношения и хорошее чувство юмора. Мы делимся экспертизой и дополняем друг друга</p>
        </div>
      </div>
    </div>

    <relations-background />

    <page-footer
      :prev="{ name: 'individualism' }"
      :next="{ name: 'motion' }"
    />
  </div>
</template>

<script>
// eslint-disable-next-line
import { TimelineMax, TweenMax } from 'gsap'
import RelationsBackground from '@/components/aboutSvg'
import PageFooter from '@/components/PageFooter'
import RouteMixin from '../mixins/route'

export default {
  name: 'relations',
  mixins: [RouteMixin],
  components: {
    RelationsBackground,
    PageFooter
  },
  mounted () {
    new TimelineMax()
      .add(TweenMax.from('.relations-bg', 0.5, { opacity: 0 }))
      .add(TweenMax.from('.page__title', 0.3, { y: '-30px', opacity: 0 }))
      .add(TweenMax.from('.page__lead', 0.3, { y: '-10px', opacity: 0 }))
  },
  beforeRouteLeave (to, from, next) {
    this.isDisabledRoute = true

    new TimelineMax()
      .add(TweenMax.to('.page__lead', 0.3, { y: '10px', opacity: 0 }))
      .add(TweenMax.to('.page__title', 0.3, { y: '30px', opacity: 0 }))
      .add(TweenMax.to('.relations-bg', 0.5, { opacity: 0 }))
      .eventCallback('onComplete', () => {
        next()
      })
  }
}
</script>
